import { EvtHeader } from "components/header";
import React from "react";
import QuadrimesterForm from "@/modules/performance/quad/form";
import { Button } from "ui/components/button";
import HeaderPortal from "components/portal/header-portal";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { generateQuadData, fetchQuadDataforForm } from "../form/read";
import { getItemsCount } from "directus/src/operations";
import Loader from "@/components/loader";
import { useNavigate } from "react-router-dom";
import { ConfirmationDialog } from "../../components/confirmation-dialog";
import { invalidateAllQueries } from "utils/utils";

const UpdateQuadrimester = () => {
  const { quadId } = useParams();
  const [showConfirm, setShowConfirm] = React.useState(false);

  const { mutate: generate, isPending: isGenerating } = useMutation({
    mutationFn: () => generateQuadData(quadId),
    onSuccess: () => {
      toast.success("Generated Successfully");
      invalidateAllQueries();
      setShowConfirm(false);
    },
    onError: (error) => toast.error(error.message || "Failed to generate"),
  });

  const { data: quad } = useQuery({
    queryKey: ["performance_review_months", quadId],
    queryFn: async () => fetchQuadDataforForm({ id: quadId }),
    enabled: !!quadId,
  });

  const { data: reviewCount = 0 } = useQuery({
    queryKey: ["performance_review", "count", quadId],
    queryFn: async () => {
      const response = await getItemsCount("performance_review", {
        aggregate: { countDistinct: ["id"] },
        query: {
          filter: {
            quadrimester: {
              id: {
                _eq: quadId,
              },
            },
          },
        },
      });
      return response?.[0]?.countDistinct.id || 0;
    },
    enabled: !!quadId,
  });

  return (
    <div className="flex-1 ">
      <EvtHeader title="Update Quadrimester" />
      {quad?.status === "ongoing" && Number(reviewCount) === 0 && (
        <HeaderPortal>
          <Button
            variant="outline"
            onClick={() => setShowConfirm(true)}
            disabled={isGenerating}
          >
            {isGenerating ? "Generating..." : "Generate Review Assignments"}
          </Button>
        </HeaderPortal>
      )}
      <ConfirmationDialog
        open={showConfirm}
        onOpenChange={setShowConfirm}
        title="Generate Review Assignments"
        description="Are you sure you want to generate review assignments for this quadrimester? This action cannot be undone."
        descriptionClassName="text-red-500"
        onConfirm={() => generate()}
        isLoading={isGenerating}
        onCancel={() => setShowConfirm(false)}
      />
      <div className="max-w-md p-6">
        <QuadrimesterForm />
      </div>
      {isGenerating && (
        <div className="fixed inset-0 z-50 bg-white/60">
          <div className="w-full h-full flex items-center justify-center">
            <Loader />
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateQuadrimester;
